var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H32V15.1111H0V8Z",
    fill: "#BA341C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4444 0H3.55556C2.61256 0 1.70819 0.374602 1.0414 1.0414C0.374602 1.70819 0 2.61256 0 3.55556L0 8H32V3.55556C32 2.61256 31.6254 1.70819 30.9586 1.0414C30.2918 0.374602 29.3874 0 28.4444 0Z",
    fill: "#080808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 23.1111H28.4444C29.3874 23.1111 30.2918 22.7365 30.9586 22.0697C31.6254 21.4029 32 20.4986 32 19.5556V15.1111H0V19.5556C0 20.4986 0.374602 21.4029 1.0414 22.0697C1.70819 22.7365 2.61256 23.1111 3.55556 23.1111Z",
    fill: "#F2CA41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.71446fb1a7e7f11156e7024251721c58.svg";
export { ForwardRef as ReactComponent };